import { render, staticRenderFns } from "./EditCreateModal.vue?vue&type=template&id=61bd414f&scoped=true"
import script from "./EditCreateModal.vue?vue&type=script&lang=js"
export * from "./EditCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd414f",
  null
  
)

export default component.exports